import { useEffect } from "react";
import { motion } from "framer-motion";
import ReactPlayer from "react-player/lazy";
import wellnessPracticeProgressStore from "../../store/wellnessPracticeProgressStore";
import WellnessProgressTracker from "../../components/WellnessProgressTracker";

import { useAudioPreference } from "../../hooks/useAudioPreference";
import { useBootstrap } from "@/features/bootstrap";
import { useAudioNavigation } from "@/hooks/useAudioNavigation";

const DEEP_BREATHE_3_DURATION_MS = 8500;


const DeepBreathe3 = () => {
  const [playing] = useAudioPreference();
  const store = wellnessPracticeProgressStore;
  const { data: user } = useBootstrap();
  const audio_url_prefix = (user?.voice ?? "english female").replace(" ", "_");

  const audioHandlers = useAudioNavigation({
    to: "/actions",
    fallbackMs: DEEP_BREATHE_3_DURATION_MS,
    beforeNavigate: () => store.setLine("line3", 100),
  });

  useEffect(() => {
    store.setLine("line3", 0);
    store.setLineProgressAnimated("line3", DEEP_BREATHE_3_DURATION_MS);
  }, [store]);

  return (
    <>
      <div className="sticky top-0 mt-10 sm:mt-0 z-10 shrink-0 bg-white sm:ml-[130px] px-0 sm:px-8 lg:px-32">
        <header className="px-4 py-4 text-center sm:px-6 sm:pb-4 sm:pt-12">
          <h1 className="mb-2 text-2xl font-bold md:text-3xl">Take a deep breath</h1>
          <p className="mx-auto text-[15px] sm:text-base text-gray-600">Let's take another calming breath</p>
        </header>
        <WellnessProgressTracker />
      </div>
      <motion.div className="flex max-h-screen flex-1 flex-row bg-white">
        <div className="h-0 w-0 overflow-hidden opacity-0">
          <ReactPlayer
            playing={playing}
            url={"audio/" + audio_url_prefix + "/deepbreathe3.wav"}
            {...audioHandlers}
          />
        </div>
        <div className="flex w-full flex-col items-center sm:ml-[130px]">
          <img
            className="sm:mt-16 mt-6 h-[48vh] md:h-[30vmax]"
            src="../images/GIF_ThirdBreath_Crop.gif"
            alt="Loading..."
            loading="lazy"
          />
        </div>
      </motion.div>
    </>
  );
};

export default DeepBreathe3;
